import cameraicon from '../assets/cameraicon.svg'

const Photoicon = () => <img src={cameraicon} style={{height:"20px",filter:"invert(1)"}} ></img>

export {Photoicon}